import * as React from 'react';
import { notification, Button, Popconfirm } from 'antd';
import { ProductNode, StockReport } from '../../schema';
import { CompanyNodeEdge, Bussiness } from '../master/Company/constants';
import { KhadiPhysicalStockForm } from './KhadiPhysicalStockForm';
import { KhadiPhysicalStockNode, khadiPhysicalStockObject } from './Constants';
import { PhysicalStockService } from '../../service/PhysicalStockService';

export class KhadiPhysicalStockEntry extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      physicalStock: JSON.parse(JSON.stringify(khadiPhysicalStockObject)),
      buttonDisabled: false,
    };
  }

  physicalStockService = new PhysicalStockService();

  onChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => {
    const physicalStock = { ...this.state.physicalStock };
    physicalStock[e.target.name] = e.target.value;
    this.setState({ physicalStock });
  };

  productChangeHandler = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number } },
    index: number,
  ) => {
    const nextState: State = {
      ...this.state,
    };
    if (nextState.physicalStock.productDetails) {
      nextState.physicalStock.productDetails[index][e.target.name] =
        e.target.value;
    }
    this.setState(nextState);
  };

  updateProductsRow = (type: string, index: number) => {
    const nextState: State = { ...this.state };
    if (type === '+') {
      nextState.physicalStock.productDetails?.push({
        date: null,
        productId: '',
        quantity: null,
        rate: 0,
        amount: 0,
        movementType: 'OPENING_STOCK',
        companyId: null,
      });
    } else {
      nextState.physicalStock.productDetails?.splice(index, 1);
    }
    this.setState(nextState);
  };

  productObjChangeHandler = (productObj: ProductNode, index: number) => {
    const nextState = { ...this.state };

    if (nextState.physicalStock.productDetails) {
      nextState.physicalStock.productDetails[index].rate =
        productObj.sellingRate;
      nextState.physicalStock.productDetails[index].quantity = (
        productObj.stock as StockReport
      ).totalStocks;
      nextState.physicalStock.productDetails[index].unitName =
        productObj.unit?.name || '';
      const physicalStockValue = (productObj as any).physicalStock
        ?.physicalStock;
      if (physicalStockValue !== undefined && physicalStockValue !== null) {
        if (!nextState.physicalStock.physicalStocks) {
          nextState.physicalStock.physicalStocks = [];
        }

        nextState.physicalStock.physicalStocks[index] = physicalStockValue;
      }
      nextState.physicalStock.productDetails[index].stockRemarks =
        (productObj as any).physicalStock?.stockRemarks || null;
      nextState.physicalStock.declarationIsChecked =
        (productObj as any).physicalStock?.declarationIsChecked || false;
    }

    this.setState(nextState);
  };

  physicalQuantityChangeHandler = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const nextState = { ...this.state };
    if (nextState.physicalStock.physicalStocks)
      nextState.physicalStock.physicalStocks[index] = Number(e.target.value);
    this.setState(nextState);
  };

  savePhysicalStock = () => {
    if (!this.state.physicalStock.declarationIsChecked) {
      notification.error({
        message: 'Declaration Required',
        description: 'Please accept the declaration before submitting.',
      });
      return;
    }
    this.setState({ buttonDisabled: true });
    const physicalStock = { ...this.state.physicalStock };
    physicalStock.companyId = this.props.company.id;
    physicalStock.branchId =
      this.props.business.type === 'branch' ? this.props.business.id : null;
    this.physicalStockService?.addKhadiPhysicalStock(
      physicalStock,
      (response) => {
        this.setState({
          physicalStock: JSON.parse(JSON.stringify(khadiPhysicalStockObject)),
        });
        this.setState({ buttonDisabled: false });
        notification.success({
          message: 'Updated',
          description: `Physical Stock Added successfully`,
        });
      },
      (error) => {
        notification.error({
          message: 'Physical Stock Error',
          description: JSON.stringify(error),
        }),
          this.setState({ buttonDisabled: false });
      },
    );
  };

  clear = () => {
    this.setState({
      physicalStock: JSON.parse(JSON.stringify(khadiPhysicalStockObject)),
    });
  };

  render() {
    return (
      <div>
        <KhadiPhysicalStockForm
          value={this.state.physicalStock}
          onChange={this.onChange}
          productChangeHandler={this.productChangeHandler}
          updateProductsRow={this.updateProductsRow}
          company={this.props.company}
          currentBusiness={this.props.business}
          physicalQuantityChangeHandler={this.physicalQuantityChangeHandler}
          productObjChangeHandler={this.productObjChangeHandler}
        />
        <Popconfirm
          title="Are you sure to clear?"
          onConfirm={this.clear}
          okText="Yes"
          cancelText="No"
        >
          <Button type="dashed" children="Clear" style={{ width: '50%' }} />
        </Popconfirm>
        <Button
          type="primary"
          onClick={this.savePhysicalStock}
          children="Submit"
          style={{ width: '50%' }}
          disabled={this.state.buttonDisabled}
        />
      </div>
    );
  }
}

interface Props {
  company: CompanyNodeEdge;
  business: Bussiness;
}

interface State {
  physicalStock: KhadiPhysicalStockNode;
  buttonDisabled: boolean;
}
